'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; // Constants


var _formConstants = require('./formConstants');

var _reduxForm = require('redux-form');

exports.default = function (reducerFn, formName) {
    return function (state, action) {
        var nextState = reducerFn(state, action);
        if (action.form !== formName) return nextState;

        switch (action.type) {
            case _reduxForm.actionTypes.START_SUBMIT:
                return _extends({}, nextState, {
                    primaryError: null
                });
            case _formConstants.FORM_SUBMISSION_FAILED:
                return _extends({}, nextState, {
                    primaryError: action.primaryError
                });
            default:
                return nextState;
        }
    };
};


//////////////////
// WEBPACK FOOTER
// ./src/client/components/form/formSubReducerWrapper.js
// module id = 229
// module chunks = 0